import React, {
  useMemo,
  useCallback,
  useState,
} from 'react'

import { useResponsiveWrapperContext } from '@usap/uicomponents'

import useProceedToCheckout from './hooks/useProceedToCheckout'
import { usePopUpContext } from '../../../../providers/PopUpProvider'
import useHandleStickyButton from './hooks/useHandleStickyButton'
import ProceedToCheckoutWmo from './ProceedToCheckoutWmo'

const ProceedToCheckout = () => {
  const [isProcessing, setIsProcessing] = useState(false)
  const [isStickyButton, setIsStickyButton] = useState(true)

  const {
    outOfStockItems,
    shouldShowOosProducts,
    cannotShipItems,
    shouldShowCannotShipProducts,
  } = usePopUpContext()

  const { isDesktop } = useResponsiveWrapperContext()

  const buttonWrapperId = useMemo(
    () => {
      if (!isDesktop && isStickyButton) {
        return 'cart__proceed-to-checkout--wrapper'
      }
      return ''
    },
    [isDesktop, isStickyButton],
  )

  const buttonLabel = useMemo(
    () => {
      if (isProcessing) return 'Processing...'
      return 'PROCEED TO CHECKOUT'
    },
    [isProcessing],
  )

  const handleProceedToCheckout = useProceedToCheckout()

  const handleAction = useCallback(
    async () => {
      if (outOfStockItems && outOfStockItems.length) {
        shouldShowOosProducts(true)
        return
      }

      if (cannotShipItems && cannotShipItems.items.length) {
        shouldShowCannotShipProducts(true)
        return
      }

      setIsProcessing(true)
      await handleProceedToCheckout()
      setIsProcessing(false)
    },
    [
      outOfStockItems,
      shouldShowOosProducts,
      cannotShipItems,
      shouldShowCannotShipProducts,
      handleProceedToCheckout,
      setIsProcessing,
    ],
  )

  const buttonElementId = 'proceedToCheckoutBtn'
  const buttonSectionId = 'cart__proceed-to-checkout--section'
  useHandleStickyButton({
    isDesktop,
    buttonSectionId,
    setIsStickyButton,
    isStickyButton,
  })

  return (
    <ProceedToCheckoutWmo
      isProcessing={isProcessing}
      handleAction={handleAction}
      buttonLabel={buttonLabel}
      buttonElementId={buttonElementId}
      buttonWrapperId={buttonWrapperId}
    />
  )
}

export default ProceedToCheckout
